import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ProductosPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = [
    'Todos',
    'Toyota',
    'Chevrolet',
    'Nissan',
    'Renault',
    'Hyundai',
    'Ford',
    'Mazda',
    'Kia',
    'Baterías',
    'Universal'
  ];

  const products = [
    {
      id: 1,
      name: "Bobina Toyota Corolla",
      image: "https://public.readdy.ai/ai/img_res/37327191036ddc1d22283525c7df2b9b.jpg",
      category: "Toyota",
      description: "Bobina de encendido original para Toyota Corolla, garantiza un encendido perfecto y máximo rendimiento",
      features: ["Calidad original", "Fácil instalación", "Garantía incluida"],
      inStock: true,
      rating: 4.8,
      reviews: 24
    },
    {
      id: 2,
      name: "Bobina Chevrolet Spark",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Chevrolet%20Spark%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=chevrolet-spark-prod&orientation=squarish",
      category: "Chevrolet",
      description: "Bobina de encendido específica para Chevrolet Spark, máximo rendimiento y durabilidad",
      features: ["Alta durabilidad", "Rendimiento óptimo", "Instalación rápida"],
      inStock: true,
      rating: 4.9,
      reviews: 18
    },
    {
      id: 3,
      name: "Bobina Renault Nissan",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/c8b2c4b6ed4401d3fce0dd0b592f481a.png",
      category: ["Nissan", "Renault"],
      description: "Bobina de encendido compatible con múltiples modelos Nissan y Renault, tecnología avanzada y confiabilidad superior",
      features: ["Compatible múltiples modelos", "Tecnología avanzada", "Larga duración"],
      inStock: true,
      rating: 4.7,
      reviews: 32,
      compatibility: ["Nissan March", "Nissan Versa", "Nissan Qashqai", "Renault Koleos"]
    },
    {
      id: 4,
      name: "Bobina Nissan X-Trail Sentra Renault Koleos",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/a7d0143fd27bf04285dc157e76a643f8.png",
      category: ["Nissan", "Renault"],
      description: "Bobina de encendido para Nissan X-Trail 2.5L, Sentra y Renault Koleos, conexión de 3 pines, alta calidad y rendimiento superior",
      features: ["Conexión 3 pines", "Motor 2.5L compatible", "Alta resistencia"],
      inStock: true,
      rating: 4.8,
      reviews: 28,
      compatibility: ["Nissan X-Trail 2.5L", "Nissan Sentra", "Renault Koleos"]
    },
    {
      id: 5,
      name: "Bobina Nissan Pathfinder Murano Quest Xterra",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/caf117d9fc7eb01274251e727bcbce08.png",
      category: "Nissan",
      description: "Bobina de encendido tipo lápiz para Nissan Pathfinder, Murano, Quest y Xterra, conexión de 3 pines, diseño compacto y alta eficiencia",
      features: ["Tipo lápiz", "Conexión 3 pines", "Diseño compacto"],
      inStock: true,
      rating: 4.6,
      reviews: 21,
      compatibility: ["Nissan Pathfinder 03-08", "Nissan Murano", "Nissan Quest 04-09", "Nissan Xterra 05-15"]
    },
    {
      id: 6,
      name: "Bobina Nissan X-Trail Pathfinder",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/ed51cc1104d91b6481f63e75ac27c78a.png",
      category: "Nissan",
      description: "Bobina de encendido para Nissan X-Trail y Pathfinder, diseño robusto y rendimiento confiable para vehículos SUV",
      features: ["Diseño robusto", "Para vehículos SUV", "Alta confiabilidad"],
      inStock: true,
      rating: 4.7,
      reviews: 19,
      compatibility: ["Nissan X-Trail", "Nissan Pathfinder"]
    },
    {
      id: 7,
      name: "Bobina Nissan Urban",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/6b49b71b59452cceb180a0c3a4c3172a.png",
      category: "Nissan",
      description: "Bobina de encendido para Nissan Urban, diseño compacto y eficiente para vehículos urbanos, tecnología avanzada y fácil instalación",
      features: ["Diseño compacto", "Eficiencia urbana", "Fácil instalación"],
      inStock: true,
      rating: 4.5,
      reviews: 17,
      compatibility: ["Nissan Urban"]
    },
    {
      id: 8,
      name: "Bobina Hyundai Accent",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Hyundai%20Accent%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=hyundai-accent-prod&orientation=squarish",
      category: "Hyundai",
      description: "Bobina de encendido para Hyundai Accent, calidad premium y eficiencia energética",
      features: ["Calidad premium", "Eficiencia energética", "Resistente al calor"],
      inStock: true,
      rating: 4.6,
      reviews: 15
    },
    {
      id: 9,
      name: "Bobina Ford Fiesta",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Ford%20Fiesta%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=ford-fiesta-prod&orientation=squarish",
      category: "Ford",
      description: "Bobina de encendido para Ford Fiesta, diseño robusto y rendimiento confiable",
      features: ["Diseño robusto", "Rendimiento confiable", "Fácil instalación"],
      inStock: true,
      rating: 4.5,
      reviews: 28
    },
    {
      id: 10,
      name: "Bobina Mazda 3",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Mazda%203%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=mazda3-prod&orientation=squarish",
      category: "Mazda",
      description: "Bobina de encendido para Mazda 3, tecnología japonesa de alta precisión",
      features: ["Tecnología japonesa", "Alta precisión", "Larga vida útil"],
      inStock: false,
      rating: 4.8,
      reviews: 19
    },
    {
      id: 11,
      name: "Bobina Kia Rio",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Kia%20Rio%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=kia-rio-prod&orientation=squarish",
      category: "Kia",
      description: "Bobina de encendido para Kia Rio, calidad coreana y precio competitivo",
      features: ["Calidad coreana", "Precio competitivo", "Instalación sencilla"],
      inStock: true,
      rating: 4.4,
      reviews: 22
    },
    {
      id: 12,
      name: "Bobina Chevrolet Aveo",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Chevrolet%20Aveo%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=chevrolet-aveo-prod&orientation=squarish",
      category: "Chevrolet",
      description: "Bobina de encendido para Chevrolet Aveo, rendimiento optimizado y durabilidad",
      features: ["Rendimiento optimizado", "Alta durabilidad", "Garantía extendida"],
      inStock: true,
      rating: 4.3,
      reviews: 16
    },
    {
      id: 13,
      name: "Bobina Toyota Yaris",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Toyota%20Yaris%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=toyota-yaris-prod&orientation=squarish",
      category: "Toyota",
      description: "Bobina de encendido para Toyota Yaris, confiabilidad japonesa comprobada",
      features: ["Confiabilidad japonesa", "Tecnología avanzada", "Bajo mantenimiento"],
      inStock: true,
      rating: 4.7,
      reviews: 31
    },
    {
      id: 14,
      name: "Bobina Nissan March",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Nissan%20March%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=nissan-march-prod&orientation=squarish",
      category: "Nissan",
      description: "Bobina de encendido para Nissan March, eficiencia y economía de combustible",
      features: ["Eficiencia energética", "Economía de combustible", "Diseño compacto"],
      inStock: true,
      rating: 4.5,
      reviews: 25
    },
    {
      id: 15,
      name: "Bobina Hyundai i10",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Hyundai%20i10%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=hyundai-i10-prod&orientation=squarish",
      category: "Hyundai",
      description: "Bobina de encendido para Hyundai i10, ideal para vehículos compactos",
      features: ["Ideal para compactos", "Bajo consumo", "Instalación simple"],
      inStock: true,
      rating: 4.2,
      reviews: 14
    },
    {
      id: 16,
      name: "Bobina Ford Ka",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Ford%20Ka%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=ford-ka-prod&orientation=squarish",
      category: "Ford",
      description: "Bobina de encendido para Ford Ka, rendimiento urbano optimizado",
      features: ["Rendimiento urbano", "Tecnología Ford", "Durabilidad probada"],
      inStock: true,
      rating: 4.4,
      reviews: 18
    },
    {
      id: 17,
      name: "Scanner Automotriz Universal",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20diagnostic%20scanner%20tool%2C%20universal%20OBD2%20scanner%20device%2C%20automotive%20diagnostic%20equipment%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=scanner-universal&orientation=squarish",
      category: "Universal",
      description: "Scanner de diagnóstico universal compatible con múltiples marcas y modelos de vehículos",
      features: ["Compatible con todas las marcas", "Diagnóstico completo", "Fácil de usar"],
      inStock: true,
      rating: 4.9,
      reviews: 45,
      compatibility: ["Toyota", "Chevrolet", "Nissan", "Hyundai", "Ford", "Mazda", "Kia", "Renault", "Volkswagen"]
    },
    {
      id: 18,
      name: "Batería Bosch S4",
      image: "https://readdy.ai/api/search-image?query=Bosch%20S4%20automotive%20battery%2C%20high-quality%20car%20battery%2C%20professional%20automotive%20battery%20with%20Bosch%20branding%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=bosch-s4-battery&orientation=squarish",
      category: "Baterías",
      description: "Batería Bosch S4 de alta calidad, tecnología alemana y máxima durabilidad para vehículos",
      features: ["Tecnología alemana", "Larga duración", "Instalación incluida"],
      inStock: true,
      rating: 4.9,
      reviews: 67,
      compatibility: ["Toyota", "Chevrolet", "Nissan", "Hyundai", "Ford", "Mazda", "Kia", "Renault"]
    },
    {
      id: 19,
      name: "Batería Bosch S5",
      image: "https://readdy.ai/api/search-image?query=Bosch%20S5%20automotive%20battery%2C%20premium%20car%20battery%2C%20professional%20automotive%20battery%20with%20Bosch%20branding%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=bosch-s5-battery&orientation=squarish",
      category: "Baterías",
      description: "Batería Bosch S5 premium, tecnología avanzada AGM para vehículos con alto consumo eléctrico",
      features: ["Tecnología AGM", "Alto rendimiento", "Resistente a vibraciones"],
      inStock: true,
      rating: 4.8,
      reviews: 52,
      compatibility: ["Vehículos con Start-Stop", "Alto consumo eléctrico", "Sistemas avanzados"]
    },
    {
      id: 20,
      name: "Batería Bosch S3",
      image: "https://readdy.ai/api/search-image?query=Bosch%20S3%20automotive%20battery%2C%20standard%20car%20battery%2C%20professional%20automotive%20battery%20with%20Bosch%20branding%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=bosch-s3-battery&orientation=squarish",
      category: "Baterías",
      description: "Batería Bosch S3 estándar, confiabilidad y calidad Bosch para uso diario",
      features: ["Calidad estándar", "Precio competitivo", "Confiabilidad Bosch"],
      inStock: true,
      rating: 4.6,
      reviews: 38,
      compatibility: ["Vehículos estándar", "Uso diario", "Sistemas básicos"]
    },
    {
      id: 21,
      name: "Bobina Kia Cerato",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/bd2176726da921cf5afbf38f1c5afaad.png",
      category: ["Kia", "Hyundai"],
      description: "Bobina de encendido para Kia Cerato 1.6, Soul 1.6 y Hyundai i30, conexión de 2 pines, alta calidad y rendimiento superior",
      features: ["Conexión 2 pines", "Motor 1.6L compatible", "Alta durabilidad"],
      inStock: true,
      rating: 4.7,
      reviews: 26,
      compatibility: ["Kia Cerato 1.6", "Kia Soul 1.6", "Hyundai i30"]
    },
    {
      id: 22,
      name: "Bobina Hyundai Kia",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/e271d96a5ed14a3accab0303a9cf10f7.png",
      category: ["Hyundai", "Kia"],
      description: "Bobina de encendido tipo lápiz para Hyundai i10 1.2, Grand i10, Kia Cerato, ix35, Sonata y Tucson. Modelo GC4278 más corta con conexión de 2 pines",
      features: ["Tipo lápiz más corta", "Conexión 2 pines", "Modelo GC4278"],
      inStock: true,
      rating: 4.8,
      reviews: 34,
      compatibility: ["Hyundai i10 1.2", "Hyundai Grand i10 08-12", "Kia Cerato", "Hyundai ix35", "Hyundai Sonata", "Hyundai Tucson"]
    },
    {
      id: 23,
      name: "Bobina Kia Cerato Hyundai Creta",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/8c77a10e506f6b4c08e91d7317a392e7.png",
      category: ["Kia", "Hyundai"],
      description: "Bobina de encendido para Kia Cerato, Soul, Rio y Hyundai i25-Creta, diseño avanzado y alta eficiencia para motores modernos",
      features: ["Compatible múltiples modelos", "Diseño avanzado", "Alta eficiencia"],
      inStock: true,
      rating: 4.6,
      reviews: 29,
      compatibility: ["Kia Cerato", "Kia Soul", "Kia Rio", "Hyundai i25", "Hyundai Creta"]
    },
    {
      id: 24,
      name: "Bobina Renault Clio Kangoo Sandero Logan Duster",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/d9969a04325ebc086d662beb98b07c5b.png",
      category: "Renault",
      description: "Bobina de encendido tipo lápiz para Renault Clio, Kangoo, Sandero 1.6, Logan 1.6 y Duster 1.6/2.0, tapa verde con conexión de 2 pines",
      features: ["Tipo lápiz", "Tapa verde", "Conexión 2 pines"],
      inStock: true,
      rating: 4.7,
      reviews: 31,
      compatibility: ["Renault Clio", "Renault Kangoo", "Renault Sandero 1.6", "Renault Logan 1.6", "Renault Duster 1.6", "Renault Duster 2.0"]
    },
    {
      id: 25,
      name: "Bobina Renault Valeo Logan Sandero Twingo",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/558b4587fd90b066becd8c5a04d97872.png",
      category: "Renault",
      description: "Bobina de encendido Valeo para Renault Logan, Sandero y Twingo, conexión de 4 pines con diseño cuadrado y tecnología original Valeo",
      features: ["Tecnología Valeo original", "Conexión 4 pines", "Diseño cuadrado"],
      inStock: true,
      rating: 4.8,
      reviews: 27,
      compatibility: ["Renault Logan", "Renault Sandero", "Renault Twingo"]
    },
    {
      id: 26,
      name: "Bobina Encendido Renault Kwid",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/dd0e61ed55fabc2ed11cdfe8898eb526.png",
      category: "Renault",
      description: "Bobina de encendido específica para Renault Kwid, diseño compacto y eficiente para motor de pequeña cilindrada, tecnología moderna y confiable",
      features: ["Diseño compacto", "Motor pequeña cilindrada", "Tecnología moderna"],
      inStock: true,
      rating: 4.6,
      reviews: 23,
      compatibility: ["Renault Kwid"]
    },
    {
      id: 27,
      name: "Bobina Chevrolet Captiva Suzuki Grand Vitara",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/462dcb8f37902e20cef266dba1a6aa28.png",
      category: ["Chevrolet", "Suzuki"],
      description: "Bobina de encendido para Chevrolet Captiva 3.6 V6 2006, Suzuki Grand Vitara 3.2 2009-2015 y Traverse 3.6, conexión de 4 pines, alta potencia para motores V6",
      features: ["Conexión 4 pines", "Motor V6 compatible", "Alta potencia"],
      inStock: true,
      rating: 4.8,
      reviews: 19,
      compatibility: ["Chevrolet Captiva 3.6 V6 2006", "Suzuki Grand Vitara 3.2 2009-2015", "Chevrolet Traverse 3.6"]
    },
    {
      id: 28,
      name: "Bobina Chevrolet Captiva Sport Orlando",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/cf715d44a53d6721833c211d58342fce.png",
      category: "Chevrolet",
      description: "Bobina de encendido para Chevrolet Captiva Sport 2.4 2009-2016, HHR 2.4 2011-2016 y Orlando 2.4, conexión de 4 pines, diseño robusto para motores 2.4L",
      features: ["Conexión 4 pines", "Motor 2.4L compatible", "Diseño robusto"],
      inStock: true,
      rating: 4.7,
      reviews: 22,
      compatibility: ["Chevrolet Captiva Sport 2.4 09-16", "Chevrolet HHR 2.4 11-16", "Chevrolet Orlando 2.4"]
    },
    {
      id: 29,
      name: "Bobina Suzuki Vitara Mazda Allegro Mitsubishi Lancer",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/a89f760733b9d481f373e3c83d5af069.png",
      category: ["Suzuki", "Mazda", "Mitsubishi"],
      description: "Bobina de encendido para Suzuki Vitara, Mazda Allegro 1.3 y Mitsubishi Lancer, conexión de 2 pines, diseño compacto y alta eficiencia para motores pequeños",
      features: ["Conexión 2 pines", "Motores pequeños", "Alta eficiencia"],
      inStock: true,
      rating: 4.5,
      reviews: 20,
      compatibility: ["Suzuki Vitara", "Mazda Allegro 1.3", "Mitsubishi Lancer"]
    },
    {
      id: 30,
      name: "Bobina Mitsubishi Lancer Outlander 2.4",
      description: "Bobina de encendido Mitsubishi Lancer Outlander 2.4 - Alta calidad y rendimiento",
      price: "$84.99",
      image: "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/a6bb806fd36eb0aab03a2153d5a7cccf.png",
      category: "Bobinas de Encendido",
      compatibility: "Mitsubishi Lancer 2.4, Mitsubishi Outlander 2.4",
      pins: "4 pines",
      rating: 4.6,
      reviews: 18
    }
  ];

  useEffect(() => {
    // Add structured data for products page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Productos Automotrices - Mechatronicx SAS",
      "description": "Equipos y herramientas profesionales para diagnóstico y reparación automotriz",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/productos`,
      "mainEntity": {
        "@type": "ItemList",
        "name": "Productos Automotrices",
        "numberOfItems": products.length,
        "itemListElement": products.slice(0, 10).map((product, index) => ({
          "@type": "Product",
          "position": index + 1,
          "name": product.name,
          "description": product.description,
          "category": Array.isArray(product.category) ? product.category.join(', ') : product.category,
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": product.rating,
            "reviewCount": product.reviews
          }
        }))
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const filteredProducts = products.filter(product => {
    const matchesCategory = selectedCategory === 'Todos' || 
                           (Array.isArray(product.category) 
                             ? product.category.includes(selectedCategory)
                             : product.category === selectedCategory);
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg fixed w-full top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                alt="Mechatronicx Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h1 className="text-xl font-bold text-gray-900">MECHATRONICX</h1>
                <p className="text-xs text-gray-600">Soluciones Electrónicas Automotrices</p>
              </div>
            </Link>
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Inicio</Link>
              <Link to="/servicios" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Servicios</Link>
              <Link to="/productos" className="text-red-600 font-semibold cursor-pointer">Productos</Link>
              <Link to="/empresas" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Empresas</Link>
              <Link to="/blog" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Blog</Link>
              <a 
                href="https://wa.me/573202047129"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-600 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base"
              >
                Cotizar Ahora
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-900 to-red-900 text-white py-20 mt-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Productos Especializados</h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Equipos y herramientas profesionales para diagnóstico, programación y reparación automotriz
          </p>
        </div>
      </section>

      {/* Filters Section */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search */}
            <div className="relative flex-1 max-w-md">
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Buscar productos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 text-sm"
              />
            </div>

            {/* Categories */}
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-red-600 text-white'
                      : 'bg-white text-gray-700 hover:bg-red-50 hover:text-red-600'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <div 
                key={product.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-64 object-cover object-top hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {Array.isArray(product.category) ? product.category.join(' / ') : product.category}
                    </span>
                  </div>
                  {!product.inStock && (
                    <div className="absolute top-4 right-4">
                      <span className="bg-gray-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                        Agotado
                      </span>
                    </div>
                  )}
                </div>
                
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">{product.name}</h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">{product.description}</p>
                  
                  {/* Rating */}
                  <div className="flex items-center mb-3">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <i 
                          key={i} 
                          className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-sm`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-gray-500 text-sm ml-2">({product.reviews})</span>
                  </div>

                  {/* Features */}
                  <ul className="space-y-1 mb-4">
                    {product.features && product.features.slice(0, 2).map((feature, idx) => (
                      <li key={idx} className="flex items-center text-xs text-gray-600">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* Compatibility for Universal products */}
                  {product.compatibility && (
                    <div className="mb-4">
                      <p className="text-xs font-semibold text-gray-700 mb-2">Compatible con:</p>
                      <div className="flex flex-wrap gap-1">
                        {Array.isArray(product.compatibility) ? (
                          <>
                            {product.compatibility.slice(0, 4).map((brand, idx) => (
                              <span key={idx} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                {brand}
                              </span>
                            ))}
                            {product.compatibility.length > 4 && (
                              <span className="text-xs text-gray-500">+{product.compatibility.length - 4} más</span>
                            )}
                          </>
                        ) : (
                          <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                            {product.compatibility}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Actions */}
                  <div className="flex gap-2">
                    <button 
                      className={`flex-1 py-2 px-4 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                        product.inStock 
                          ? 'bg-red-600 text-white hover:bg-red-700' 
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                      disabled={!product.inStock}
                    >
                      {product.inStock ? 'Consultar Precio' : 'No Disponible'}
                    </button>
                    <button className="bg-gray-100 text-gray-700 p-2 rounded-full hover:bg-gray-200 transition-colors cursor-pointer">
                      <i className="ri-heart-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">No se encontraron productos</h3>
              <p className="text-gray-500">Intenta con otros términos de búsqueda o categorías</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">¿No encuentras lo que buscas?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Contáctanos y te ayudaremos a encontrar el equipo perfecto para tus necesidades
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
              Contactar Asesor
            </button>
            <button className="border-2 border-red-600 text-red-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-600 hover:text-white transition-all whitespace-nowrap cursor-pointer">
              Ver Catálogo Completo
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <img 
                  src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                  alt="Mechatronicx Logo" 
                  className="h-10 w-auto"
                />
                <div>
                  <h3 className="text-lg font-bold">MECHATRONICX</h3>
                  <p className="text-xs text-gray-400">Soluciones Electrónicas</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4">
                Equipos profesionales para diagnóstico y reparación automotriz.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Categorías</h4>
              <ul className="space-y-3">
                {categories.slice(1).map((category) => (
                  <li key={category}>
                    <button 
                      onClick={() => setSelectedCategory(category)}
                      className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                    >
                      {category}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Contacto</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">Ave Cra 30 #29-09 Sur, Bogotá DC</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">320 204 7129</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">Gerencia@mechatronicxsas.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Síguenos</h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/people/Mechatronicx-Especializado/100083428926459/?mibextid=wwXIfr&rdid=8FbzdNPEAxjlrs6r&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14SQyQT5X5o%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg md:text-xl"></i>
                </a>
                <a href="https://www.instagram.com/mechatronicxsas/?igsh=MTh0eDQ3MWhnMmh1NA%3D%3D" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg md:text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 Mechatronicx SAS. Todos los derechos reservados. | 
              <a href="https://maiketing.agency" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1 cursor-pointer">
                Powered by MAIketing.agency
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProductosPage;
